import React from 'react';

const Login = React.lazy(() => import('./login'));
const ProductLogs = React.lazy(() => import('./component/logs'));
const ConfigLogs = React.lazy(() => import('./component/configLogs'));
const ErrorLogs = React.lazy(() => import('./component/errorLogs'));
const ProductStatus = React.lazy(() => import('./component/status'));
const DebugLive = React.lazy(() => import('./component/debugLive'));
const ActivityLogs = React.lazy(() => import('./component/activityLogs'));
const DeviceActivityLogs = React.lazy(() => import('./component/activityLogs/deviceActivityLogs'));

const route = [
    { path: '/login', exact: true, name: 'Login', component: Login },
    { path: '/product/logs/:productId/:imei', exact: true, name: 'ProductLogs', component: ProductLogs },
    { path: '/product/config-logs/:productId/:imei', exact: true, name: 'ConfigLogs', component: ConfigLogs },
    { path: '/product/error-logs/:productId/:imei', exact: true, name: 'ErrorLogs', component: ErrorLogs },
    { path: '/product/status/:productId/:imei', exact: true, name: 'ProductStatus', component: ProductStatus },
    { path: '/product/debug/:productId/:imei', exact: true, name: 'DebugLive', component: DebugLive },
    { path: '/activity-logs', exact: true, name: 'ActivityLogs', component: ActivityLogs },
    { path: '/product/activity-logs/:productId/:imei', exact: true, name: 'DeviceActivityLogs', component: DeviceActivityLogs },
];

export default route;